import React from "react";
import parse from "html-react-parser";
import * as E from "../../elementor";
import ArrowIcon from "../../images/arrow-narrow-right.svg";
import SmoothScrollLink from "../transition/smooth-scroll-link";

interface Props {
  icon: E.ImageWidget;
  heading: E.HeadingWidget;
  text: E.TextEditorWidget;
  button: E.ButtonWidget;
}

export const InteractiveCard: React.FC<Props> = (props) => {
  const { heading, button, icon, text } = props;

  const renderCardContent = () => {
    return (
      <div className="interactive-card">
        <div className="interactive-card-content">
          <img src={icon?.image?.fileUrl} alt="" />
          <h3 className="interactive-card-heading">
            {parse(heading?.title || "")}
          </h3>
          <div className="interactive-card-text">{text?.parse()}</div>
        </div>
        <div className="interactive-card-button">
          <div>{button?.text}</div>
          <img className="arrow-icon" src={ArrowIcon} />
        </div>
      </div>
    );
  };

  const buttonIsScrollLink = button?.link?.includes("#");
  return (
    <>
      {buttonIsScrollLink ? (
        <SmoothScrollLink
          offset={0}
          link_id={button.button_css_id || ""}
          offsetMobile={0}
          id={button.link as string}
        >
          {renderCardContent()}
        </SmoothScrollLink>
      ) : (
        <a href={button?.link} id={button?.button_css_id || ""}>
          {renderCardContent()}
        </a>
      )}
    </>
  );
};

export default InteractiveCard;
